import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import {
  Button,
  MessageBox,
  SpacingVertical,
  Text,
  Flex,
  Link,
  Badge,
  Divider
} from 'mailup-web-components'
import { deliverabilityIndexState } from '../recoil/state/page'
import { notifyParent } from 'mailup-react-helpers'
import styled from '@emotion/styled'
import { getDeliverabilityScoreColor } from 'Helpers/deliverabilityIndex'
import { openHelp } from 'Helpers/openHelp'
import { modalOpportunityState } from 'Components/ModalOpportunity/recoil/state/modal'

const StyledMessageBox = styled(MessageBox)`
  a {
    text-decoration: underline;
    color: inherit;
    font-weight: inherit;
  }
  a:hover {
    text-decoration: underline;
  }
`

const BoxBrandShield = () => {
  const intl = useIntl()
  const {
    ScoreData: { Score }
  } = useRecoilValue(deliverabilityIndexState)
  const setModalBrandShieldState = useSetRecoilState(modalOpportunityState)
  const goToDashboard = () => {
    notifyParent('openHelp', [openHelp('deliverabilityIndex')])
  }

  const openModal = () => {
    setModalBrandShieldState(prev => ({
      ...prev,
      show: true,
      type: 'brandShield'
    }))
  }

  return (
    <>
      <StyledMessageBox
        variant='help'
        title={
          <Flex alignItems='center' gap='8px'>
            <Text variant='bold'>
              {intl.formatMessage(
                { id: 'Load.SmtpPlus.SenderDomainTipTitle' },
                {
                  link: chunks => (
                    <Link variant='extralight' onClick={goToDashboard}>
                      {chunks}
                    </Link>
                  )
                }
              )}
            </Text>
            <Badge
              type={getDeliverabilityScoreColor(Score)}
              text={`${Math.floor(Score)}/100`}
            />
          </Flex>
        }
      >
        <SpacingVertical variant='16' />
        <Text variant='light'>
          {intl.formatMessage(
            { id: 'Load.SmtpPlus.SenderDomainTipBody' },
            {
              strong: chunks => <strong>{chunks}</strong>
            }
          )}
        </Text>
        <SpacingVertical />
        <Divider />
        <SpacingVertical />

        <Flex alignItems='center' justifyContent='space-between'>
          <Text variant='light'>
            {intl.formatMessage(
              { id: 'Load.SmtpPlus.SenderDomainTipCtaBody' },
              {
                strong: chunks => <strong>{chunks}</strong>
              }
            )}
          </Text>
          <Button kind='primary' onClick={openModal}>
            {intl.formatMessage({ id: 'Load.SmtpPlus.SenderDomainTipCta' })}
          </Button>
        </Flex>
      </StyledMessageBox>
      <SpacingVertical />
    </>
  )
}

export default BoxBrandShield
